<template>
<div id="app">
    <div class="container-fluid p-0 m-0 page-container">
        <div class="row m-0 w-100">
            <div class="col-lg-4 col-xl-3 p-0 custom-h-sm-50 info-block flex-element">
                <h1 class="text-center pt-3 w-25 mx-auto d-block">
                    <b-img src="banner-light.png" fluid alt="Accessibel" :class="[{ 'sidebar-disabled': !loaded }]"></b-img>
                </h1>
                <sidebar @walkSelected="walkSelected" :mapLoaded="loaded"></sidebar>
            </div>
            <div class="col-lg-8 col-xl-9 p-0 custom-h-sm-50">
                <map-view :selectedWalkId="selectedWalkId" :zoomToSelectedWalk="idUpdated" :selectWalk="selectWalk" @mapLoaded="mapLoaded"></map-view>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import MapView from "./components/MapView.vue";
import Sidebar from "./components/Sidebar.vue";

export default {
    name: "App",
    components: {
        MapView,
        Sidebar,
    },

    data() {
        return {
            points: [],
            selectedWalkId: null,
            selectWalk: null,
            idUpdated: 0,
            loaded: false,
        };
    },

    methods: {
        walkSelected(id, selectWalk) {
            this.selectedWalkId = id;
            this.selectWalk = selectWalk;
            this.idUpdated += 1;
        },
        mapLoaded() {
            this.loaded = true;
        },
    },
};
</script>

<style>
html,
body {
    height: 100%;
    background: #0b9098;
}

#app {
    height: 100%;
}

h6 {
    font-size: 18px;
}

.sidebar-disabled {
    opacity: 0.25;
}

.page-container {
    display: flex;
    height: 100%;
    background: #262a2f;
}

.map {
    flex-grow: 1;
    order: 1;
    width: 100%;
    height: 100%;
}

.info-block {
    color: white;
    overflow-y: auto;
}

body:not(.modal-open) {
    padding-right: 0px !important;
}

.content_container {
    padding: 5px 5px 5px 5px;
    background: #262a2f;
}

.card {
    align-items: center;
}

.content {
    margin-top: 30px;
}

img {
    max-width: 100%;
}

.close {
    color: #fff;
    opacity: 1;
}

.modal-header {
    border-bottom: unset;
}

.modal-footer {
    border-top: unset;
}

.modal-content {
    border: 2px solid #17a2b8;
    background-color: #1a1d20;
    color: white;
}

.mapboxgl-popup-content {
    border: 2px solid #17a2b8;
    background-color: #1a1d20;
    color: white;
    overflow-x: auto;
}

.mapboxgl-popup-tip {
    border: 25px solid transparent;
    border-top-color: #17a2b8 !important;
}

::-webkit-scrollbar {
    background: #0b9098;
}

::-webkit-scrollbar-thumb {
    background-color: #004f54;
}

.mapboxgl-popup-content img {
    border: #343a40 solid 1px;
}

.mapboxgl-popup-close-button {
    visibility: hidden;
}

.table td,
.table th {
    border-top: unset;
    border-bottom: #004f54 solid 1px;
}

.btn {
    border-radius: 0;
}

@media screen and (max-width: 768px) {
    p {
        font-size: 12px;
    }
}

@media screen and (min-width: 576px) {
    .row {
        flex-wrap: nowrap;
    }
}

@media screen and (max-width: 576px) {
    .custom-h-sm-50 {
        height: 50%;
    }
}
</style>
